import { render, staticRenderFns } from "./InstrumentJigServerTable.vue?vue&type=template&id=0f488ab6"
import script from "./InstrumentJigServerTable.vue?vue&type=script&lang=js"
export * from "./InstrumentJigServerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports